<template>
    <section class="UniversitySearchResults">
        <h2 :class="{ Blink: loading }">Redirecting to University Search...</h2>
    </section>
</template>

<script setup lang="ts">
import { SearchType } from "@app/enums/SearchType";
import { useSearchTypeRedirect } from "@app/composables/useSearchTypeRedirect";

const { loading } = useSearchTypeRedirect(SearchType.UNIVERSITY);
</script>

<style scoped lang="scss">
    .UniversitySearchResults {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        @include PaddingAreas(0.25, 0);
    }
    .Blink {
        animation: blink-animation 1s linear infinite;
    }

    @keyframes blink-animation {
        0%, 100% {
            opacity: 1;
        }
        50% {
            opacity: 0;
        }
    }

</style>